import React, { useEffect } from "react";
import {
  Typography
} from "@material-ui/core";
import QAListResult from "../component/QAListResult"
import HomeMenuCR from "../component/portal/home/customer/HomeMenu"
import HomeMenuEE from "../component/portal/home/employee/HomeMenu"
import { getQAList } from "../api/helpline/qa"
import { useGlobalState, useDispatch } from "../provider/Provider";
import { cisUser, ssUser } from "../User";


interface Props {
  handleListItemClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, text: string) => void
  handleClickQAno: (num: string) => void,
  handleHomeHistory: () => void,
  handleError: (err: any) => void,
}

const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!

const Home: React.FC<Props> = (props) => {
  const globalState = useGlobalState('user')
  const globalbpState = useGlobalState('page')
  const globalqalistState = useGlobalState('qalist')
  const globalconlistState = useGlobalState('contractlist')
  const dispatch = useDispatch()
  const { userId, token, role, ssFlg } = globalState
  const { handleHomeHistory, handleListItemClick, handleClickQAno, handleError } = props
  //お知らせ情報取得getparam有
  let tableTitle: string = 'OPEN中のQ&A'
  const pageSize: number = 10
  const [loading, setLoading] = React.useState(false)
  const qastatusclscd = ['0', '1', '2', '3']
  useEffect(() => {
    if (userId && token && role && ssFlg) {
      if (globalqalistState.length === 0 || !globalbpState.backpage) {
        setLoading(true)
        if (role === rolecustomer) {//顧客
          getQAList(userId, userId, token, role, '', '', qastatusclscd.join(','), null, null, '', '', '').then(res => {
            dispatch({
              type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: res, contractlist: globalconlistState
            })
            setLoading(false)
          }).catch(err => { setLoading(false); handleError(err) })
        } else if (ssUser(ssFlg)) {//SS
          getQAList('', userId, token, role, '', '', ['0', '1', '2', '3','d'].join(','), null, null, '', '', '').then(res => {
            dispatch({
              type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: res, contractlist: globalconlistState
            })
            setLoading(false)
          }).catch(err => { setLoading(false); handleError(err) })
        } else {//一般社員
          getQAList('', userId, token, role, '', '', qastatusclscd.join(','), null, null, '', '', userId).then(res => {
            dispatch({
              type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: res, contractlist: globalconlistState
            })
            setLoading(false)
          }).catch(err => { setLoading(false); handleError(err) })
        }
      }
    }
  }, [globalState, globalbpState])

  handleHomeHistory()
  return (
    <React.Fragment>
      <Typography variant="h6">
        ヘルプラインポータル
      </Typography>
      {role === rolecustomer && <HomeMenuCR handleListItemClick={handleListItemClick} />}
      {cisUser(role) && <HomeMenuEE handleListItemClick={handleListItemClick} />}
      <QAListResult handleClickQAno={handleClickQAno} tableTitle={tableTitle} pageSize={pageSize} loading={loading} />
    </React.Fragment >
  )
}

export default Home;